import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map2",
  "use": "icon-map2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-map2\"><g clip-path=\"url(#icon-map2_clip0_6839_21317)\"><path fill-rule=\"evenodd\" d=\"M4 5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm0 8a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z\" clip-rule=\"evenodd\" /></g><defs><clipPath id=\"icon-map2_clip0_6839_21317\"><path d=\"M0 0H24V24H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol